import { render } from "./GlossaryPage.vue?vue&type=template&id=74d4d73c&scoped=true&ts=true"
import script from "./GlossaryPage.vue?vue&type=script&lang=ts"
export * from "./GlossaryPage.vue?vue&type=script&lang=ts"

import "./GlossaryPage.vue?vue&type=style&index=0&id=74d4d73c&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d4d73c"]])

export default __exports__